import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

const QuestionWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

const QuestionText = styled.div`
  font-size: 1.3em;
  @media (min-width: 768px) {
    font-size: 1.6em;
  }
  max-width: 900px;
  margin: 0px auto;
  text-align: left;
  display: flex;
  align-items: center;

  svg {
    font-size: 3em;
    @media (min-width: 768px) {
      font-size: 4em;
    }
    margin-right: -15px;
    opacity: .1;
  }
`

const QuestionImage = styled.div`
  max-height: 900px;
  margin: 0px auto;
  display: inline-block;
  img {
    max-width: 100%;
    height: auto;
    max-height: 50vh;
    margin-bottom: 1em;
  }
`

const QuestionEmbed = styled.div`
  max-height: 900px;
  margin: 0px auto;
  display: inline-block;
  iframe {
    max-width: 100%;
    margin-bottom: 1em;
  }
`

const EmbedDiv = styled.div`
  margin-top: -8.5rem;
  z-index: 2;
  position: relative;
  background: white;
`

const EmbedLoading = styled.i`
  z-index: 1;
  font-size: 5rem;
  margin: 2rem 0rem;
`

export default class Question extends React.Component {
  static propTypes = {
    question: PropTypes.object.isRequired
  }

  static defaultProps = {
    question: {}
  }


  render() {
    let { question } = this.props

    return (
      <QuestionWrapper>
        <QuestionEmbed>
          {
            question.question_embed
              ? (
                <div>
                  <EmbedLoading className="fas fa-spinner fa-spin" />
                  <EmbedDiv >
                    <div dangerouslySetInnerHTML={{ __html: question.question_embed }} />
                  </EmbedDiv>
                </div>
              )
              : null
          }
        </QuestionEmbed>
        <QuestionImage>
          {
            question.question_image_url
              ? (
                <img src={question.question_image_url}
                    alt='question-image'/>
              )
              : null
          }
        </QuestionImage>
        <QuestionText>
          <i className="fas fa-question-circle"></i>{ `${question.question_text}` }
        </QuestionText>
      </QuestionWrapper>
    )
  }
}
